/**
 * @file App组件使用的工具方法
 */
import axios from 'axios';

import * as constants from '@/tools/constants.js';

import * as tools from '@/tools/tools.js';

import * as utils from '@/tools/utils.js';


import * as apis from '@/apis/apis.js';

import * as airecogApis from '@/apis/airecog-apis.js';


const instance = axios.create();



// 启动ai识别服务
const startAiScaleFn = async () => {
	let result;
	try {
		result = await instance({
			method: 'post',
			headers: {
				'content-type': 'application/json'
			},
			url: 'http://127.0.0.1:4444/start'
		});
	} catch (e) {
		console.log('/start catch e', e);
		return false;
	}
	console.log('/start result.data', result.data);
	return tools.objectGet(result.data, 'code') === 0 ? true : false;
}




// 启动ai识别服务 并 初始化
export const startAiScaleAndInitFn = async that => {

	const startAiScaleResult = await startAiScaleFn();
	
	// var startAiScaleResult = true;
	
	console.log('await startAiScaleFn startAiScaleResult', startAiScaleResult);

	if (startAiScaleResult) {
		// await that.sleepFn(1.8);
		const scaleSecretKeyResult = await apis.scaleSecretKeyApi(that);
		console.log('await apis.scaleSecretKeyApi scaleSecretKeyResult', scaleSecretKeyResult);
		if (that.checkResultDatasFn(scaleSecretKeyResult)) {
			if (scaleSecretKeyResult) {
				const result = await airecogApis.initAirecogApi(that, scaleSecretKeyResult);
				console.log('await airecogApis.initAirecogApi result', result);
			}
		}
	}
}



// 处理本地设置默认数据
export const initDefaultSetFn = async that => {
	// 初始化键盘设置
	if (!Object.keys(constants.keyboardStateEnum).includes(utils.handleKeyboardSetFn().getFn())) {
		utils.handleKeyboardSetFn().setFn(constants.keyboardStateEnum.openState);
	}

	// 初始化ai识别设置
	if (!Object.keys(constants.airecogStateEnum).includes(utils.handleAirecogSetFn().getFn())) {
		utils.handleAirecogSetFn().setFn(constants.airecogStateEnum.airecogCloseState);
	}

	// 初始化权限
	that.$store.commit('setStateDataFn', {
		permissionListDatas: utils.handlePermissionFn().getFn()
	});

	await handleBaseSetFn(that);

}

// 处理基础设置数据
export const handleBaseSetFn = async that => {
	if(!that.getHostFn()) return false;

	const result = await that.$fetch({
		method: 'post',
		resultDataType: 'Array',
		url: '/syapi/config/appointConfig',
		data: {
			names: [
				'desk_color', // 主题颜色
				'desk_logo', // 收银台logo
			],
		}
	});

	console.log('handleBaseSetFn /syapi/config/appointConfig result', result);

	if (that.checkNetworkSuccessFn(result)) {

		const getValFn = key => {

			const list = result.data;

			let index = -1;
			for (const i in list) {
				if (list[i].name == key) {
					index = i;
					break;
				}
			}
			if (index < 0) return '';
			return tools.objectGetString(list[index], 'value');
		}

		const data = {};


		const logo = getValFn('desk_logo'),
			mainColor = getValFn('desk_color');

		if (that.$store.state.logo != logo) {
			data.logo = logo;
		}
		if (that.$store.state.mainColor != mainColor) {
			data.mainColor = mainColor;
		}
		if (Object.keys(data).length) {
			that.$store.commit('setStateDataFn', data);
		}
	}

}


// WEBPACK FOOTER //
// ./src/tools/app-func.js